module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/Jupiter-Ascending.715ad71.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/Jupiter-Ascending.jpg
// module id = hj9E
// module chunks = 0